import { reactive } from 'vue'

/*
	Bottom sheets live in the URL (?sheet=name), so the Android/browser Back button
	closes the top sheet before it leaves the page. Data a sheet needs (which order
	the ⋯ menu is for, etc.) is kept in `sheetPayload` by sheet name.
*/
export const sheetPayload = reactive({})

let router = null

export function installSheets(appRouter) {
	router = appRouter
}

function withoutSheet(query) {
	const next = { ...query }
	delete next.sheet
	return next
}

export function isSheetOpen(route, name) {
	return route.query.sheet === name
}

export function openSheet(name, payload) {
	if (payload !== undefined) sheetPayload[name] = payload
	const route = router.currentRoute.value
	if (route.query.sheet === name) return
	// A sheet opened from another sheet replaces it, so one Back still leaves the page.
	const method = route.query.sheet ? 'replace' : 'push'
	return router[method]({ path: route.path, hash: route.hash, query: { ...route.query, sheet: name } })
}

export function closeSheet(name) {
	const route = router.currentRoute.value
	if (name && route.query.sheet !== name) return
	if (!route.query.sheet) return

	// When the entry under this one is the same page without the sheet, step back to it
	// so the history stays clean; otherwise (opened from a shared link) just drop the param.
	const base = router.resolve({ path: route.path, query: withoutSheet(route.query), hash: route.hash }).fullPath
	if (window.history.state?.back === base) {
		// router.back() returns before the browser has moved; resolve once it has, so an alert or
		// sheet opened next isn't undone by this Back.
		return new Promise((resolve) => {
			const done = () => {
				stop()
				clearTimeout(timer)
				resolve()
			}
			const stop = router.afterEach(done)
			const timer = setTimeout(done, 700)
			router.back()
		})
	}
	return router.replace({ path: route.path, hash: route.hash, query: withoutSheet(route.query) })
}
